import { AuxiliumComponent } from "../auxilium-component";

export class DropdownHeader extends AuxiliumComponent {
	constructor() {
		super();

		this.size = this.getAttribute("size") ?? "5";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("chip-header", this.childNodes, { size: this.size }));
	}
}